import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { cleanMaskedNumber } from '@/utilities'
import { handleError } from '@/store/handle-error'

export const PEPhoneCardActions = {
  initPePhoneCard: ({ commit }, index) => {
    commit('setPePhoneCardLock', { index, lock: true })
  },
  pePhoneMultipleCardCreate: async ({ dispatch }, sections) => {
    return sections.reduce((acc, section) => {
      if (acc) return acc.then(_ => dispatch('pePhoneCardCreate', { section, index: 'new' }))
      else return dispatch('pePhoneCardCreate', { section, index: 'new' })
    }, null)
  },
  pePhoneCardCreate: async ({ commit, getters }, { section }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        phones: {
          country_id: section.country_id,
          country_prefix: section.country_prefix,
          extension: section.extension,
          owner: section.owner,
          party_id: party.id,
          phone_number: cleanMaskedNumber(section.phone_number),
          phone_type: section.phone_type,
          preferred_text: section.preferred_text,
          preferred_voice: section.preferred_voice,
        },
      }).
      then(({ data }) => {
        commit('setPePhoneCardLock', { index: 'new', lock: true })
        commit('setPePhoneCardLock', { index: data.id, lock: true })
        commit('pePatchCharacteristicNew', {
          characteristic: 'phones',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  pePhoneCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/phones/${section.id}`).
      then(({ data }) => {
        commit('setPePhoneCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'phones',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  pePhoneCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        phones: {
          country_id: section.country_id,
          country_prefix: section.country_prefix,
          extension: section.extension,
          owner: section.owner,
          party_id: party.id,
          phone_number: cleanMaskedNumber(section.phone_number),
          phone_type: section.phone_type,
          preferred_text: section.preferred_text,
          preferred_voice: section.preferred_voice,
        },
        id,
      }).
      then(({ data }) => {
        commit('setPePhoneCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'phones',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  pePhoneCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          phones: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const phones = data.phones || []

        commit('setPePhoneCardLock', { index, lock: true })
        commit('pePatchParty', {
          phones,
        })
      }).
      catch(handleError)
  },
  pePhoneCardAddSection: ({ commit }) => {
    commit('setPePhoneCardLock', { index: 'new', lock: false })
    commit('addPePhoneCardSection', {
      id: null,
      country_id: null,
      country_iso_code: '',
      country_prefix: '',
      extension: '',
      owner: '',
      phone_number: '',
      phone_type: '',
      preferred_text: false,
      preferred_voice: false,
    })
  },
  pePhoneCardRefreshAll: async ({ commit, getters }) => {
    const party = getters.peParty

    return axiosRequest.
      get(`/parties/${party.id}/phones`).
      then(({ data }) => {
        const phones = data.phones || []

        commit('pePatchParty', {
          phones,
        })

        return data
      }).
      catch(handleError)
  },
}

export const PEPhoneCardMutations = {
  setPePhoneCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.PhoneCard) Vue.set(state.partyEdit.partySections, 'PhoneCard', {})
    Vue.set(state.partyEdit.partySections.PhoneCard, index, lock)
  },
  addPePhoneCardSection: (state, section) => {
    state.partyEdit.party.phones.push(section)
  },
  pePhoneCardCreateUndo: state => {
    state.partyEdit.party.phones.pop()
    Vue.set(state.partyEdit.partySections.PhoneCard, 'new', true)
  },
}

export const PEPhoneCardGetters = {
  pePhoneCardLock: state => index => state.partyEdit.partySections.PhoneCard?.[index] ?? true,
  pePhoneCardHasNewSection: (_, getters) => !!getters.peParty.phones?.find(phone => phone.id === null),
}
